module.exports = __webpack_public_path__ + "img/panelView_strong_Bg_89_2_3.ae84158b.png";